var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1F9D4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92D3F5",
    d: "M17,61v-4c0-5,5-9,10-9c6,5,12,5,18,0c5,0,10,4,10,9v4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M24.9,31c0,9,4.9,14,11,14c6,0,11.1-5,11.1-14c0.0164-1.7179-0.3241-3.4205-1-5c-3-3-7-8-7-8c-4,3-7,6-13,7 C26,25,24.9,26,24.9,31z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1B31C",
    d: "M36,12c-10,0-14,7-14,14c0,6.7,0,12.4,3.5,12.9c0.2,0.5,0.4,0.9,0.6,1.4 c0.5866,0.9827,1.2919,1.8896,2.1,2.7c2.0255,1.8025,4.6964,2.7048,7.4,2.5h0.3c2.7037,0.2048,5.3745-0.6975,7.4-2.5 c0.8667-0.757,1.5796-1.6737,2.1-2.7c0.3745-0.7139,0.7084-1.4484,1-2.2L46.1,39C50,38.9,50,33,50,26S46,12,36,12z M40,39 c0,0.7-1.6,2-4,2s-4-1.3-4-2v-1.9c0.0012-0.5518,0.4482-0.9988,1-1l3,1.5l3.1-1.5c0.5209-0.0314,0.9686,0.3653,1,0.8862 c0.0023,0.0379,0.0023,0.0759,0,0.1138L40,39z M44.9,34.8c0,0-1.9,3-2.7-1.2c-4.2842-1.2-8.8158-1.2-13.1,0 c-0.7,4.2-2.7,1.2-2.7,1.2c-0.6363-1.3242-1.1712-2.6948-1.6-4.1c0.1925-1.8639,0.5608-3.7054,1.1-5.5c7.2-1,12.9-7.1,12.9-7.1 s1.4,1.2,7.2,7.8c0.3133,1.3181,0.5471,2.6538,0.7,4C46.3277,31.6082,45.722,33.257,44.9,34.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.5,39.2 C20.7,39.2,22,33,22,26s4-14,14-14s14,7,14,14s0.9,13.4-4,13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17,60v-3c0-5,5-9,10-9 c6,5,12,5,18,0c5,0,10,4,10,9v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,29c0,1.1046-0.8954,2-2,2s-2-0.8954-2-2s0.8954-2,2-2C41.0032,27.0032,41.8968,27.8968,41.9,29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9,29c0,1.1046-0.8954,2-2,2c-1.1046,0-2-0.8954-2-2s0.8954-2,2-2C33.0032,27.0032,33.8968,27.8968,33.9,29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M47,31c0.0164-1.7179-0.3241-3.4205-1-5 c-3-3-7-8-7-8c-4,3-7,6-13,7c0,0-1.1,1-1.1,6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9,36.5c0.2165,0.4972-0.0061,1.0761-0.5,1.3c-1.0802,0.5583-2.2845,0.8336-3.5,0.8 c-1.1781-0.0154-2.3386-0.2885-3.4-0.8c-0.4939-0.2239-0.7165-0.8028-0.5-1.3c0.1662-0.4582,0.6724-0.6948,1.1306-0.5286 C33.1541,35.98,33.1773,35.9895,33.2,36c0.1,0,0.1,0,0.1,0.1c1.5809,0.9,3.5191,0.9,5.1,0 C38.9269,35.8138,39.5856,35.9895,39.9,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M24.9,31 c-0.2,3.1-0.3,6.6,1.2,9.3c0.5866,0.9827,1.2919,1.8896,2.1,2.7c2.0576,1.7465,4.7048,2.6408,7.4,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M47,31 c-0.2804,1.4441-0.9357,2.7891-1.9,3.9c0,0-1.9,3-2.7-1.2c-4.2842-1.2-8.8158-1.2-13.1,0c-0.8,4.2-2.7,1.2-2.7,1.2 c-0.7775-1.1859-1.3207-2.5097-1.6-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M47,31.4 c0.3271,3.0586-0.2281,6.1469-1.6,8.9c-0.5204,1.0263-1.2333,1.943-2.1,2.7c-2.0255,1.8025-4.6964,2.7048-7.4,2.5h-0.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F9D4);
export default __webpack_public_path__ + "static/media/1F9D4.8040812a2c63ebd6a1291b5ab1039651.svg";
export { ForwardRef as ReactComponent };